import React, { useState, useEffect } from 'react';

const LandingPage = ({ onNavigate }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsTablet(window.innerWidth > 768 && window.innerWidth <= 1024);
    };

    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigation = (page) => {
    onNavigate(page);
    setIsMenuOpen(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      overflow: 'hidden'
    }}>
      {/* Header */}
      <header style={{
        backgroundColor: '#ffffff',
        boxShadow: scrolled ? '0 4px 16px rgba(0, 0, 0, 0.12)' : '0 2px 8px rgba(0, 0, 0, 0.08)',
        position: 'sticky',
        top: 0,
        zIndex: 50,
        transition: 'all 0.3s ease'
      }}>
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: isMobile ? '0 1rem' : '0 2rem'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: isMobile ? '1rem 0' : '1.25rem 0',
            transition: 'padding 0.3s ease'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: isMobile ? '0.75rem' : '1rem'
            }}>
              <img
                src="/srims_logo.png"
                alt="SRIMS Logo"
                style={{
                  height: isMobile ? '50px' : isTablet ? '70px' : '80px',
                  width: 'auto',
                  objectFit: 'contain',
                  transition: 'height 0.3s ease'
                }}
              />
              <div style={{
                marginLeft: isMobile ? '0.5rem' : '1rem',
                borderLeft: '3px solid #0047AB',
                paddingLeft: isMobile ? '0.75rem' : '1rem'
              }}>
                <p style={{
                  fontSize: isMobile ? '12px' : isTablet ? '16px' : '18px',
                  color: '#0047AB',
                  margin: 0,
                  fontWeight: '700',
                  letterSpacing: '0.5px',
                  whiteSpace: 'nowrap'
                }}>HOSTEL PORTAL</p>
              </div>
            </div>

            {!isMobile && (
              <div style={{
                display: 'flex',
                gap: isTablet ? '0.75rem' : '1rem',
                alignItems: 'center'
              }}>
                <button onClick={() => handleNavigation('application-status')} style={{
                  background: 'linear-gradient(135deg, #0047AB 0%, #003087 100%)',
                  color: 'white',
                  padding: isTablet ? '10px 20px' : '12px 28px',
                  borderRadius: '8px',
                  border: 'none',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 12px rgba(0, 71, 171, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: isTablet ? '14px' : '15px'
                }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(0, 71, 171, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 12px rgba(0, 71, 171, 0.3)';
                  }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                  Check Status
                </button>
                <button onClick={() => handleNavigation('student-register')} style={{
                  background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                  color: 'white',
                  padding: isTablet ? '10px 20px' : '12px 28px',
                  borderRadius: '8px',
                  border: 'none',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
                  fontSize: isTablet ? '14px' : '15px'
                }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(16, 185, 129, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)';
                  }}>
                  Register Now
                </button>
                <button onClick={() => handleNavigation('hostel-login')} style={{
                  background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                  color: 'white',
                  padding: isTablet ? '10px 20px' : '12px 28px',
                  borderRadius: '8px',
                  border: 'none',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 12px rgba(245, 158, 11, 0.3)',
                  fontSize: isTablet ? '14px' : '15px'
                }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(245, 158, 11, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 12px rgba(245, 158, 11, 0.3)';
                  }}>
                  Login
                </button>
              </div>
            )}

            {isMobile && (
              <button onClick={toggleMenu} style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '0.75rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'transform 0.3s ease',
                transform: isMenuOpen ? 'rotate(90deg)' : 'rotate(0deg)'
              }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#0047AB" strokeWidth="2.5">
                  {isMenuOpen ? (
                    <path d="M18 6L6 18M6 6l12 12" />
                  ) : (
                    <path d="M3 12h18M3 6h18M3 18h18" />
                  )}
                </svg>
              </button>
            )}
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobile && (
          <div style={{
            backgroundColor: '#ffffff',
            borderTop: '1px solid #e2e8f0',
            maxHeight: isMenuOpen ? '500px' : '0',
            overflow: 'hidden',
            transition: 'max-height 0.4s ease, padding 0.4s ease',
            padding: isMenuOpen ? '1rem' : '0 1rem'
          }}>
            <nav style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.875rem',
              opacity: isMenuOpen ? 1 : 0,
              transition: 'opacity 0.3s ease'
            }}>
              <button onClick={() => handleNavigation('application-status')} style={{
                background: 'linear-gradient(135deg, #0047AB 0%, #003087 100%)',
                color: 'white',
                padding: '14px 20px',
                borderRadius: '10px',
                border: 'none',
                fontWeight: '600',
                cursor: 'pointer',
                fontSize: '15px',
                boxShadow: '0 4px 12px rgba(0, 71, 171, 0.25)',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
                onTouchStart={(e) => {
                  e.target.style.transform = 'scale(0.98)';
                }}
                onTouchEnd={(e) => {
                  e.target.style.transform = 'scale(1)';
                }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                Check Application Status
              </button>
              <button onClick={() => handleNavigation('student-register')} style={{
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                color: 'white',
                padding: '14px 20px',
                borderRadius: '10px',
                border: 'none',
                fontWeight: '600',
                cursor: 'pointer',
                fontSize: '15px',
                boxShadow: '0 4px 12px rgba(16, 185, 129, 0.25)',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
                onTouchStart={(e) => {
                  e.target.style.transform = 'scale(0.98)';
                }}
                onTouchEnd={(e) => {
                  e.target.style.transform = 'scale(1)';
                }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="8.5" cy="7" r="4" />
                  <line x1="20" y1="8" x2="20" y2="14" />
                  <line x1="23" y1="11" x2="17" y2="11" />
                </svg>
                Register for Hostel
              </button>
              <button onClick={() => handleNavigation('hostel-login')} style={{
                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                color: 'white',
                padding: '14px 20px',
                borderRadius: '10px',
                border: 'none',
                fontWeight: '600',
                cursor: 'pointer',
                fontSize: '15px',
                boxShadow: '0 4px 12px rgba(245, 158, 11, 0.25)',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
                onTouchStart={(e) => {
                  e.target.style.transform = 'scale(0.98)';
                }}
                onTouchEnd={(e) => {
                  e.target.style.transform = 'scale(1)';
                }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                  <polyline points="10 17 15 12 10 7" />
                  <line x1="15" y1="12" x2="3" y2="12" />
                </svg>
                Student Login
              </button>
            </nav>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #0047AB 0%, #003087 50%, #002060 100%)',
        color: 'white',
        padding: isMobile ? '3rem 1.25rem' : isTablet ? '4.5rem 2rem' : '6rem 1.5rem',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Animated Background Elements */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.1,
          backgroundImage: `
            radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.3) 0%, transparent 50%), 
            radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.3) 0%, transparent 50%),
            radial-gradient(circle at 40% 10%, rgba(255, 255, 255, 0.2) 0%, transparent 40%)
          `,
          animation: 'pulse 8s ease-in-out infinite'
        }} />

        {/* Decorative Circles */}
        <div style={{
          position: 'absolute',
          top: '-100px',
          right: '-100px',
          width: '300px',
          height: '300px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%)',
          animation: 'float 6s ease-in-out infinite'
        }} />
        <div style={{
          position: 'absolute',
          bottom: '-80px',
          left: '-80px',
          width: '250px',
          height: '250px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(255, 255, 255, 0.08) 0%, transparent 70%)',
          animation: 'float 8s ease-in-out infinite reverse'
        }} />

        <style>{`
          @keyframes pulse {
            0%, 100% { opacity: 0.08; }
            50% { opacity: 0.12; }
          }
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
          }
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>

        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          position: 'relative',
          zIndex: 1
        }}>
          <div style={{
            textAlign: 'center',
            maxWidth: '900px',
            margin: '0 auto',
            animation: 'fadeInUp 0.8s ease-out'
          }}>
            <h1 style={{
              fontSize: isMobile ? '1.85rem' : isTablet ? '2.75rem' : '3.75rem',
              fontWeight: 'bold',
              marginBottom: '1rem',
              lineHeight: 1.2,
              letterSpacing: '-0.5px',
              textShadow: '0 2px 10px rgba(0, 0, 0, 0.2)'
            }}>
              Welcome to SRIMS & Sanaka Hospitals
            </h1>
            <h2 style={{
              fontSize: isMobile ? '1.35rem' : isTablet ? '1.85rem' : '2.25rem',
              fontWeight: '600',
              marginBottom: '1.5rem',
              opacity: 0.95,
              letterSpacing: '-0.3px',
              textShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
            }}>
              Hostel Portal
            </h2>
            <p style={{
              fontSize: isMobile ? '1rem' : isTablet ? '1.15rem' : '1.35rem',
              lineHeight: '1.8',
              marginBottom: '2.5rem',
              opacity: 0.92,
              maxWidth: isMobile ? '100%' : '750px',
              margin: '0 auto 2.5rem auto',
              textShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
            }}>
              Access hostel services
              Manage Accommodation, Applications, Requests
              Stay Connected            </p>
            <div style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: isMobile ? '1rem' : '1.25rem',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '2rem'
            }}>
              <button onClick={() => handleNavigation('student-register')} style={{
                background: 'white',
                color: '#0047AB',
                padding: isMobile ? '16px 36px' : isTablet ? '17px 38px' : '18px 40px',
                borderRadius: '12px',
                border: 'none',
                fontWeight: '700',
                fontSize: isMobile ? '16px' : '17px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                width: isMobile ? '100%' : 'auto',
                justifyContent: 'center',
                maxWidth: isMobile ? '100%' : 'none'
              }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-3px)';
                  e.target.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.25)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.2)';
                }}
                onTouchStart={(e) => {
                  e.target.style.transform = 'scale(0.98)';
                }}
                onTouchEnd={(e) => {
                  e.target.style.transform = 'scale(1)';
                }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="8.5" cy="7" r="4" />
                  <line x1="20" y1="8" x2="20" y2="14" />
                  <line x1="23" y1="11" x2="17" y2="11" />
                </svg>
                Register for Hostel
              </button>
              <button onClick={() => handleNavigation('hostel-login')} style={{
                background: 'rgba(255, 255, 255, 0.15)',
                color: 'white',
                padding: isMobile ? '16px 36px' : isTablet ? '17px 38px' : '18px 40px',
                borderRadius: '12px',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                fontWeight: '700',
                fontSize: isMobile ? '16px' : '17px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                backdropFilter: 'blur(10px)',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                width: isMobile ? '100%' : 'auto',
                justifyContent: 'center',
                maxWidth: isMobile ? '100%' : 'none'
              }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.25)';
                  e.target.style.transform = 'translateY(-3px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.15)';
                  e.target.style.transform = 'translateY(0)';
                }}
                onTouchStart={(e) => {
                  e.target.style.transform = 'scale(0.98)';
                  e.target.style.background = 'rgba(255, 255, 255, 0.25)';
                }}
                onTouchEnd={(e) => {
                  e.target.style.transform = 'scale(1)';
                  e.target.style.background = 'rgba(255, 255, 255, 0.15)';
                }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                  <polyline points="10 17 15 12 10 7" />
                  <line x1="15" y1="12" x2="3" y2="12" />
                </svg>
                Login
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Information */}
      <section style={{
        padding: isMobile ? '3rem 1.25rem' : isTablet ? '4rem 1.5rem' : '5rem 1.5rem',
        backgroundColor: '#f8fafc'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #0047AB 0%, #003087 100%)',
            borderRadius: isMobile ? '20px' : '24px',
            padding: isMobile ? '2.5rem 1.5rem' : isTablet ? '3.5rem 2.5rem' : '4rem 3rem',
            color: 'white',
            textAlign: 'center',
            boxShadow: '0 20px 60px rgba(0, 71, 171, 0.25)',
            position: 'relative',
            overflow: 'hidden'
          }}>
            {/* Decorative Background Pattern */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              opacity: 0.05,
              backgroundImage: `
                repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255, 255, 255, 0.1) 35px, rgba(255, 255, 255, 0.1) 70px)
              `
            }} />

            <div style={{ position: 'relative', zIndex: 1 }}>
              <h2 style={{
                fontSize: isMobile ? '1.75rem' : isTablet ? '2.25rem' : '2.75rem',
                fontWeight: 'bold',
                marginBottom: '1rem',
                textShadow: '0 2px 10px rgba(0, 0, 0, 0.15)'
              }}>Need Assistance?</h2>
              <p style={{
                fontSize: isMobile ? '1.05rem' : isTablet ? '1.1rem' : '1.2rem',
                marginBottom: isMobile ? '2rem' : '3rem',
                opacity: 0.92,
                maxWidth: '650px',
                margin: '0 auto',
                marginBottom: isMobile ? '2rem' : '3rem',
                lineHeight: '1.7',
                textShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
              }}>
                Our hostel administration team is here to help you with any queries or concerns
              </p>
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : isTablet ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
                gap: isMobile ? '1.25rem' : '2rem',
                justifyContent: 'center',
                alignItems: 'stretch'
              }}>
                <div style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.12)',
                  padding: isMobile ? '1.75rem 1.5rem' : '2rem',
                  borderRadius: '16px',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  transition: 'all 0.3s ease',
                  cursor: 'default'
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.18)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.12)';
                  }}>
                  <div style={{
                    marginBottom: '1rem',
                    fontSize: isMobile ? '2.25rem' : '2.5rem',
                    animation: 'float 3s ease-in-out infinite'
                  }}>📧</div>
                  <div style={{
                    fontSize: '0.9rem',
                    opacity: 0.85,
                    marginBottom: '0.75rem',
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                  }}>Email Address</div>
                  <div style={{
                    fontSize: isMobile ? '1rem' : '1.1rem',
                    fontWeight: '700',
                    wordBreak: 'break-word'
                  }}>srims@setgoi.com</div>
                </div>
                <div style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.12)',
                  padding: isMobile ? '1.75rem 1.5rem' : '2rem',
                  borderRadius: '16px',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  transition: 'all 0.3s ease',
                  cursor: 'default'
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.18)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.12)';
                  }}>
                  <div style={{
                    marginBottom: '1rem',
                    fontSize: isMobile ? '2.25rem' : '2.5rem',
                    animation: 'float 3s ease-in-out infinite 0.3s'
                  }}>📞</div>
                  <div style={{
                    fontSize: '0.9rem',
                    opacity: 0.85,
                    marginBottom: '0.75rem',
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                  }}>Contact Number</div>
                  <div style={{
                    fontSize: isMobile ? '1rem' : '1.1rem',
                    fontWeight: '700'
                  }}>+91 9817877877</div>
                </div>
                <div style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.12)',
                  padding: isMobile ? '1.75rem 1.5rem' : '2rem',
                  borderRadius: '16px',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  transition: 'all 0.3s ease',
                  cursor: 'default',
                  gridColumn: isTablet && !isMobile ? 'span 2' : 'auto'
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.18)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.12)';
                  }}>
                  <div style={{
                    marginBottom: '1rem',
                    fontSize: isMobile ? '2.25rem' : '2.5rem',
                    animation: 'float 3s ease-in-out infinite 0.6s'
                  }}>🕒</div>
                  <div style={{
                    fontSize: '0.9rem',
                    opacity: 0.85,
                    marginBottom: '0.75rem',
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                  }}>Office Hours</div>
                  <div style={{
                    fontSize: isMobile ? '1rem' : '1.1rem',
                    fontWeight: '700'
                  }}>24 X 7</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        backgroundColor: '#0f172a',
        color: '#cbd5e1',
        padding: isMobile ? '2.5rem 0 1.5rem 0' : '3rem 0 2rem 0'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: isMobile ? '0 1.25rem' : '0 1.5rem'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : isTablet ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
            gap: isMobile ? '2.5rem' : '3rem',
            marginBottom: '2.5rem'
          }}>
            <div style={{
              gridColumn: isTablet && !isMobile ? 'span 2' : 'auto'
            }}>
              <div style={{
                marginBottom: '1.25rem'
              }}>
                <img
                  src="/srims_logo.png"
                  alt="SRIMS Logo"
                  style={{
                    height: isMobile ? '60px' : '70px',
                    width: 'auto',
                    objectFit: 'contain',
                    filter: 'brightness(0) invert(1)'
                  }}
                />
              </div>
            </div>

            <div>
              <h4 style={{
                fontSize: isMobile ? '17px' : '18px',
                fontWeight: 'bold',
                color: 'white',
                marginBottom: '1.25rem'
              }}>Quick Links</h4>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0
              }}>
                {[
                  { label: 'Application Status', action: 'application-status' },
                  { label: 'Student Registration', action: 'student-register' },
                  { label: 'Login', action: 'hostel-login' },
                  { label: 'Privacy Policy', action: 'privacy-policy' },
                ].map((link, index) => (
                  <li key={index} style={{ marginBottom: '10px' }}>
                    <button
                      onClick={() => handleNavigation(link.action)}
                      style={{
                        color: '#94a3b8',
                        background: 'none',
                        border: 'none',
                        fontSize: isMobile ? '14px' : '15px',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        padding: 0,
                        textAlign: 'left'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.color = '#0047AB';
                        e.target.style.transform = 'translateX(5px)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.color = '#94a3b8';
                        e.target.style.transform = 'translateX(0)';
                      }}
                    >{link.label}</button>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 style={{
                fontSize: isMobile ? '17px' : '18px',
                fontWeight: 'bold',
                color: 'white',
                marginBottom: '1.25rem'
              }}>Contact Information</h4>
              <div style={{
                fontSize: isMobile ? '14px' : '15px',
                color: '#94a3b8',
                lineHeight: '2'
              }}>
                <p style={{
                  margin: '0 0 10px 0',
                  display: 'flex',
                  alignItems: 'start',
                  gap: '10px',
                  wordBreak: 'break-word'
                }}>
                  <span style={{ fontSize: '18px', flexShrink: 0 }}>📧</span>
                  <span>srims@setgoi.com</span>
                </p>
                <p style={{
                  margin: '0 0 10px 0',
                  display: 'flex',
                  alignItems: 'start',
                  gap: '10px'
                }}>
                  <span style={{ fontSize: '18px', flexShrink: 0 }}>📞</span>
                  <span>+91 9817877877</span>
                </p>
                <p style={{
                  margin: '0',
                  display: 'flex',
                  alignItems: 'start',
                  gap: '10px'
                }}>
                  <span style={{ fontSize: '18px', flexShrink: 0 }}>📍</span>
                  <span>Durgapur, West Bengal, India</span>
                </p>
              </div>
            </div>
          </div>

          <div style={{
            borderTop: '1px solid #1e293b',
            paddingTop: isMobile ? '1.5rem' : '2rem',
            textAlign: 'center'
          }}>
            <p style={{
              fontSize: isMobile ? '13px' : '14px',
              margin: 0,
              color: '#64748b',
              lineHeight: '1.6'
            }}>
              © 2025 Shri Ramkrishna Institute of Medical Sciences & Sanaka Hospitals. All rights reserved.
            </p>
            <p style={{
              fontSize: isMobile ? '12px' : '13px',
              margin: '8px 0 0 0',
              color: '#475569'
            }}>
              Hostel Portal | Designed for Student Convenience
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;